import { Injectable } from '@angular/core';
import {
  ErkomItemFollowUp
} from '@shared/models';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErkomFollowUpService {
  MS_IN_A_DAY = 86400000
  #erkomFollowUpOrders = new BehaviorSubject<ErkomItemFollowUp[]>([])

  get erkomFollowUpOrders(): Observable<ErkomItemFollowUp[]> {
    return this.#erkomFollowUpOrders.asObservable()
  }

  setErkomFollowUpOrders(orders: ErkomItemFollowUp[]) {
    this.#erkomFollowUpOrders.next(orders)
  }

  fetchErkomByID(id: number): void {
    this.setErkomFollowUpOrders(
      [
        { date: new Date(Date.now() - (22 * this.MS_IN_A_DAY)), state: 'Pendiente de Aprobación', user: 'Médico 1' },
        { date: new Date(Date.now() - (16 * this.MS_IN_A_DAY)), state: 'Orden Aprobada', user: 'Usuario Pampamed' },
        { date: new Date(Date.now() - (15 * this.MS_IN_A_DAY)), state: 'Pendiente de plano', user: 'Usuario Scanmed' },
        { date: new Date(Date.now() - (9 * this.MS_IN_A_DAY)), state: 'Plano cargado', user: 'Usuario Scanmed' },
        { date: new Date(Date.now() - (7 * this.MS_IN_A_DAY)), state: 'Plano aprobado / Pendiente de fabricación', user: 'Usuario Pampamed' },
        { date: new Date(Date.now() - (4 * this.MS_IN_A_DAY)), state: 'Producto en Fabricación', user: 'Fabricante' },
        { date: new Date(Date.now() - (2 * this.MS_IN_A_DAY)), state: 'Producto Fabricado', user: 'Fabricante' },
        { date: new Date(), state: 'Control de calidad aprobado', user: 'Usuario Pampamed' },
      ]
    )
  }


}
